module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAASFBMVEUAAADN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uRMjigqAAAAF3RSTlMAZ0yM6kUZC/K3pyVfOdHfbcc8mXA1T63ifaIAAACISURBVBjThdDBEoMgDATQFVGCAmptu///pyV0ylg4+A45LJMdAMW8eyHF7zN+3MhqdCjWjRfbWlYt/1it8Gx4YGJnwsLOAqvzzOPU41HLBFoNJCbAah2zMsykTW9SYijhwc6BJzsDnLAhDjD9NbOhXS7C9eURX48apcEBNZTwMibmpFr1a299APTaFzu6N1mmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_news.png
// module id = QGpR
// module chunks = 15